import { fg } from '@atlaskit/platform-feature-flags';

import { DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI } from '../../../types/default-cloud-graph-campaign-entity-ati';
import { DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI } from '../../../types/default-cloud-graph-case-entity-ati';
import { DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI } from '../../../types/default-cloud-graph-customer-contact-entity-ati';
import { DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI } from '../../../types/default-cloud-graph-customer-org-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI } from '../../../types/default-cloud-graph-deal-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type FilterId } from '../../../types/filters';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import {
	NounSubtypeKey,
	type TypeFilterValue3PEntities,
	TypeFilterValueKey,
} from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { SalesforceIcon, SalesforceIconBorderless, SalesforceSearchResultIcon } from './icon';

const getSalesforce3PTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();
	// Entries are ordered alphabetically by display label.
	config.set(TypeFilterValueKey.Campaign, {
		entities3P: [...DEFAULT_CLOUD_GRAPH_CAMPAIGN_ENTITY_ATI],
		subTypes3P: [],
	});
	if (fg('rovo-fps-3p-ux-salesforce-case-noun')) {
		config.set(TypeFilterValueKey.Case, {
			entities3P: [...DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI],
			subTypes3P: [],
		});
	}
	config.set(TypeFilterValueKey.CustomerContact, {
		entities3P: [...DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI],
		subTypes3P: [],
	});
	config.set(TypeFilterValueKey.CustomerOrg, {
		entities3P: DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI,
		subTypes3P: [],
	});
	config.set(TypeFilterValueKey.Deal, {
		entities3P: [
			...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
			...DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI,
		],
		subTypes3P: [NounSubtypeKey.Deal],
	});
	return config;
};

export const salesforceConfig: ThirdPartyConfig = {
	displayName: 'Salesforce',
	id: 'salesforce',
	resourceType: ProductResourceTypes3P.Salesforce,
	icon: get3PLogo(SalesforceIcon, 'Salesforce', 'medium'),
	iconBorderless: get3PLogo(SalesforceIconBorderless, 'Salesforce', 'small'),
	searchResultIcon: get3PLogo(SalesforceSearchResultIcon, 'Salesforce', 'large'),
	integrationAri: 'ari:cloud:platform::integration/salesforce',
	// Use getters to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
	get typeFilterConfig() {
		return getSalesforce3PTypeFilterConfig();
	},
	get filters(): FilterId[] {
		const base: FilterId[] = [
			'lastUpdated',
			'onlyTitleMatch',
			'lastUpdatedBy',
			'createdBy',
			'owner',
			'opportunityStatus',
			'closeDate',
		];
		if (
			fg('rovo-fps-3p-ux-salesforce-dynamic-stage-filter') ||
			fg('rovo-studio-3p-ux-salesforce-dynamic-stage-filter')
		) {
			base.push('salesforceStage');
		}
		if (
			fg('rovo-fps-3p-ux-sf-campaign-status-filter') ||
			fg('rovo-studio-3p-ux-sf-campaign-status-filter')
		) {
			base.push('campaignStatus');
		}
		base.push('caseStatus');
		return base;
	},
	requiresOauth: true,
	isEnabled: () => true,
};
